const CacheDataTerms = {
    in: {},
    out: {},
};

export default CacheDataTerms;
